import { BREAKPOINTS } from "./globals";

export const isSM = (): boolean => {
    return typeof window !== "undefined" && window.innerWidth > (BREAKPOINTS.sm as number);
};

export const isMD = (): boolean => {
    return typeof window !== "undefined" && window.innerWidth > (BREAKPOINTS.md as number);
};
